module.exports = __webpack_public_path__ + "static/media/einstein-header.cf026255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Dashboard/einstein-header.svg
// module id = ./src/Dashboard/einstein-header.svg
// module chunks = 0